module.exports = __webpack_public_path__ + "img/Rellena_Microconcreto R150.4c8955ba.png";